
import { Component, Emit, Vue, Watch } from "vue-property-decorator";
import { Prop } from "vue-property-decorator";
import { Format } from '../../core/helpers/formatHelper';

type CheckboxValueType = boolean | "true" | "false";

@Component({})
export default class CheckBox extends Vue {
  @Prop({ default: false }) value!: CheckboxValueType;
  @Prop() required!: boolean;
  @Prop() error!: string;
  checked: boolean = false;

  isNull(value: string) {
    return Format.IsNull(value);
  }

  @Watch("value")
  modelChanged(value: CheckboxValueType) {
    this.checked = value === true || value === "true" ? true : false;
  }
  mounted() {
    this.checked = this.value === true || this.value === "true" ? true : false;
  }

  @Emit("input")
  onChange(event: Event) {
    return (event.target as HTMLInputElement | null)?.value;
  }
}
